import { ScrollField } from '../util/scrollField';

interface CalendarTimeEntryFieldProps {
  timeList: {
    dateLabel: string;
    onClick: () => void;
    selectStyle: string;
  }[];
}
export const CalendarTimeEntryField = ({
  timeList,
}: CalendarTimeEntryFieldProps) => {
  return (
    <div className={'calendar-time-field'}>
      <ScrollField orientation={'horizontal'}>
        <div className={'calendar-time-content'}>
          {(timeList ?? []).map((item, idx) => (
            <div className={item.selectStyle} onClick={item.onClick} key={idx}>
              <span>{item.dateLabel}</span>
            </div>
          ))}
        </div>
      </ScrollField>
    </div>
  );
};
